/**
 * Media URL Helpers
 * Fixes storage URLs for Windows compatibility
 */

// Use same base URL as API service (without /v1 path)
// e.g. https://chatoo.me/api/v1 → https://chatoo.me/api
// e.g. http://127.0.0.1:8000/api/v1 → http://127.0.0.1:8000
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api/v1').replace('/v1', '');


/**
 * Convert storage URL to API URL
 * @param {string} url - Original URL from backend
 * @returns {string} - Corrected URL
 */
export const fixMediaUrl = (url) => {
  if (!url) return null;

  // Déjà une URL absolue complète (http/https) → retourner tel quel
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Chemin storage/ (sans slash initial) ex: "storage/profiles/image.png"
  if (url.startsWith('storage/')) {
    return `${API_BASE_URL}/${url}`;
  }

  // Chemin /storage/ (avec slash initial) ex: "/storage/profiles/image.png"
  if (url.startsWith('/storage/')) {
    return `${API_BASE_URL}${url}`;
  }

  // Stories via ancien endpoint API
  if (url.includes('/storage/stories/')) {
    const filename = url.split('/storage/stories/').pop();
    return `${API_BASE_URL}/api/v1/storage/stories/${filename}`;
  }

  // Retourner tel quel si aucune correspondance
  return url;
};

/**
 * Get full URL with API base
 * @param {string} path - Relative path
 * @returns {string} - Full URL
 */
export const getFullUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};

export default {
  fixMediaUrl,
  getFullUrl,
};
